import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

import OrdinaryOfferingAmountInput from './OrdinaryOfferingAmountInput';
import PredefinedOfferingAmountRadio from './PredefinedOfferingAmountRadio';

const OfferingAmount = forwardRef(
  (
    {
      allowFreeOfferings,
      clearErrors,
      hidePredefinedAmounts,
      loading,
      massOfferingAmount,
      name,
      onBlur,
      onChange,
      setError,
      value,
      showLabel,
      displayOwnAmountFirst,
      minimalMassOfferingAmount,
    },
    ref,
  ) => {
    if (hidePredefinedAmounts || (massOfferingAmount?.predefinedValues?.length ?? 0) <= 1) {
      return (
        <OrdinaryOfferingAmountInput
          allowFreeOfferings={allowFreeOfferings}
          loading={loading}
          minimalValue={minimalMassOfferingAmount ?? massOfferingAmount.minimalValue}
          name={name}
          onBlur={onBlur}
          onChange={onChange}
          ref={ref}
        />
      );
    }

    return (
      <PredefinedOfferingAmountRadio
        allowFreeOfferings={allowFreeOfferings}
        massOfferingAmount={massOfferingAmount}
        minimalMassOfferingAmount={minimalMassOfferingAmount ?? massOfferingAmount.minimalValue}
        onChange={onChange}
        setError={setError}
        clearErrors={clearErrors}
        name={name}
        optionalFreeOfferingsErrorMessage="Aby złożyć niższą ofiarę skontaktuj się bezpośrednio z kancelarią parafialną."
        value={value}
        showLabel={showLabel}
        displayOwnAmountFirst={displayOwnAmountFirst ?? false}
      />
    );
  },
);

OfferingAmount.propTypes = {
  loading: PropTypes.bool,
  allowFreeOfferings: PropTypes.bool,
  massOfferingAmount: PropTypes.shape({
    predefinedValues: PropTypes.array,
    allowOwnAmount: PropTypes.bool,
    minimalValue: PropTypes.number,
  }).isRequired,
  minimalMassOfferingAmount: PropTypes.number, // can be undefined, and it will default to massOfferingAmount.minimalValue
  onChange: PropTypes.func,
  name: PropTypes.string,
  setError: PropTypes.func,
  clearErrors: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.number,
  hidePredefinedAmounts: PropTypes.bool,
  showLabel: PropTypes.bool,
  displayOwnAmountFirst: PropTypes.bool,
};

export default OfferingAmount;
